import { render } from "./OneSideFadedDivider.vue?vue&type=template&id=21cb6e12"
import script from "./OneSideFadedDivider.vue?vue&type=script&lang=js"
export * from "./OneSideFadedDivider.vue?vue&type=script&lang=js"

import exportComponent from "E:\\mb\\user_dashboard-dev\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__